import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import TablePagination from '@material-ui/core/TablePagination';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import DataGridPaginationActions from './DataGridPaginationActions';
import styled from 'styled-components';

const StyledPagination = styled(TablePagination)`
  && {
    @media (max-width: ${props => props.theme.breakpoints.values.sm - 1}px) {
      .MuiTablePagination-toolbar {
        flex-wrap: wrap;
        justify-content: center;
        padding-top: ${props => props.theme.spacing(1)}px;
        padding-right: ${props => props.theme.spacing(1)}px;
        padding-left: ${props => props.theme.spacing(1)}px;
      }
    }
  }
`;

const DataGridPagination = () => {
  const intl = useIntl();
  const { data, pagination = {} } = useDataSourceContext();
  const {
    activePage,
    goToPage,
    itemCount,
    itemsPerPage = 10,
    itemsPerPageOptions,
    setItemsPerPage,
  } = pagination;

  /**
   * Handle the change page event. Sets the active page.
   * @param {Object} event
   * @param {number} page
   */
  const handleChangePage = (event, page) => {
    goToPage(page);
  };

  /**
   * Handle the change rows per page event. Sets the rows per page.
   * @param {number} event
   */
  const handleChangeRowsPerPage = event => {
    setItemsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <StyledPagination
      component="div"
      count={itemCount ? parseInt(itemCount, 10) : data.length}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={activePage}
      rowsPerPage={itemsPerPage}
      rowsPerPageOptions={itemsPerPageOptions}
      labelRowsPerPage={intl.formatMessage({
        id: 'dataGrid.pagination.rowsPerPage',
        defaultMessage: 'Rows per page:',
        description: 'Data grid rows per page label',
      })}
      labelDisplayedRows={({ from, to, count }) => {
        let toLabel = itemCount !== undefined ? to : to + from - 1;
        let countLabel = itemCount;

        if (toLabel < 0) {
          toLabel = 0;
        }

        if (!itemCount && count < itemsPerPage) {
          countLabel = toLabel;
        } else if (!itemCount) {
          countLabel = intl.formatMessage({
            id: 'dataGrid.pagination.many',
            defaultMessage: 'many',
            description: 'Label when the total number of rows are unknown',
          });
        }

        return intl.formatMessage(
          {
            id: 'dataGrid.pagination.displayedRows',
            defaultMessage: '{from}-{to} of {count}',
            description: 'Data grid displayed rows label',
          },
          {
            from,
            to: toLabel,
            count: countLabel,
          },
        );
      }}
      ActionsComponent={DataGridPaginationActions}
    />
  );
};

export default DataGridPagination;
